import SessionStorageUtils from 'data/session-storage/utils';

const Settings = {
orf: () => {
    return {
        OIDC_CLIENT_ID:"2584ce03dbe44ae5ad35974cf0cf5eff",
        OIDC_AUTHORITY: "https://access.auth.dev.nwea.org/cip-edu/",
        HOME_URL: "https://orf01-admin.mapnwea.org/nextgen-report",
        SILENT_RENEW_URL: "https://orf01-admin.mapnwea.org/nextgen-report/renew.html`",
        post_logout_redirect_uri: "https://orf01-admin.mapnwea.org/nextgen-report",
        scope: 'openid profile email',
        response_type: 'code',
        automaticSilentRenew: true,  
    };
},
prod: () => {
    return {
        OIDC_CLIENT_ID:"f54cb40bf0e84108bc38bead387159ce",
        OIDC_AUTHORITY: "https://access.auth.nwea.org/cip-edu/",
        HOME_URL: "https://teach.mapnwea.org/nextgen-report/",
        SILENT_RENEW_URL: "https://teach.mapnwea.org/nextgen-report/renew.html`",
        post_logout_redirect_uri: "https://teach.mapnwea.org/nextgen-report/",
        scope: 'openid profile email',
        response_type: 'code',
        automaticSilentRenew: true,  
    };
},
integration: () => {
    return {
        OIDC_CLIENT_ID:"93fb8ccbbc044d4894d6305d451107ae",
        OIDC_AUTHORITY: "https://access.auth.int.nwea.org/cip-edu/",
        HOME_URL: "https://int03-admin.mapnwea.org/nextgen-report",
        SILENT_RENEW_URL: "https://int03-admin.mapnwea.org/nextgen-report/renew.html`",
        post_logout_redirect_uri: "https://int03-admin.mapnwea.org/nextgen-report",
        scope: 'openid profile email',
        response_type: 'code',
        automaticSilentRenew: true,  
    };
},
perf: () => {
    return {
        OIDC_CLIENT_ID:"8ce4b3a273534cd193fcb6146823c64e",
        OIDC_AUTHORITY: "https://access.auth.perf.nwea.org/cip-edu/",
        HOME_URL: "https://perf01-admin.mapnwea.org/nextgen-report",
        SILENT_RENEW_URL: "https://perf01-admin.mapnwea.org/nextgen-report/renew.html`",
        post_logout_redirect_uri: "https://perf01-admin.mapnwea.org/nextgen-report",
        scope: 'openid profile email',
        response_type: 'code',
        automaticSilentRenew: true,
    };
},
}

const getEnvironmentSettings = () => {
    let environmentSettings;
    let envName = "prod";
        if (window.location.href.indexOf("orf01")> -1)
            envName ="development";
        else if (window.location.href.indexOf("int03") > -1 )
             envName ="integration";
        else if (window.location.href.indexOf("perf01") > -1)
            envName = "perf";
        else if (window.location.href.indexOf("localhost") > -1)
            envName = "local"  ;
        else
        envName = "prod";

    switch (envName) {
        case 'local':
            environmentSettings = Settings.orf();
            break;
        case 'development':
            environmentSettings = Settings.orf();
            break;
        case 'automation':
            environmentSettings = Settings.orf();
            break;
        case 'integration':
            environmentSettings = Settings.integration();
            break;
        case 'orf':
            environmentSettings = Settings.orf();
            break;
        case 'perf':
            environmentSettings = Settings.perf();
            break;
        default:
            environmentSettings = Settings.prod();
    }
    return environmentSettings;
};


export const environments = {
    testEnvironments: ['local', 'development', 'orf'],
    developmentEnvironments: ['development', 'local'],
};

export default getEnvironmentSettings();